import {
    useEffect,
    Fragment,
    useState,
    type FC
} from "react";
import {
    AccessibilityInfo,
    Platform,
    View
} from "react-native";
import type ISkeletonGroupProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Text from "../../../text";

const SkeletonGroup: FC<ISkeletonGroupProps> = ({
    loadingLabel: loadingLabelProp,
    customLocalize,
    customTheme,
    loadedLabel,
    placeholder,
    isLoading,
    children,
    style,
    ...props
}) => {
    const {
        borders
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const [
        announcement,
        setAnnouncement
    ] = useState<string>("");

    const {
        status: statusDynamicStyle
    } = useStyles({
        borders
    });

    const loadingLabel = loadingLabelProp ?? localize("loading");

    useEffect(() => {
        const nextAnnouncement = isLoading ? loadingLabel : loadedLabel ?? "";

        setAnnouncement(nextAnnouncement);

        if(Platform.OS === "ios" && nextAnnouncement) {
            AccessibilityInfo.announceForAccessibility(nextAnnouncement);
        }
    }, [
        loadingLabel,
        loadedLabel,
        isLoading
    ]);

    return <Fragment>
        <View
            {...props}
            aria-busy={isLoading}
            style={style}
        >
            {isLoading ? placeholder : children}
        </View>
        <View
            style={[
                stylesheet.status,
                statusDynamicStyle
            ]}
            aria-live="polite"
            role="status"
        >
            {
                announcement ?
                    <Text
                        customTheme={customTheme}
                    >
                        {announcement}
                    </Text>
                :
                    null
            }
        </View>
    </Fragment>;
};
export default SkeletonGroup;
